
import Urls from "./url";
import { User } from "../models/data";

let user = {};

const setUser = async () => {
    // You can implement setUser functionality here if needed.
}

export const createMedia = async (file: File) => {
    let user: User;
    const value = localStorage.getItem('user');
    if (value) {
        user = JSON.parse(value);
        const createResponse = await fetch(Urls('createMediaUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                //'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                "Accept": "application/json",
                'Authorization': 'Bearer ' + user.token,
                'Content-Disposition': 'attachment; filename=' + file.name,
                'Content-Type': 'image/jpeg',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin-when-cross-origin, unsafe-url
            body: file // body data type must match "Content-Type" header
        });

        if (createResponse.ok) {
            let message = await createResponse.json();
            return {
                message: message.id,
                error: null
            };
        } else {
            return {
                message: null,
                error: createResponse.statusText
            };
        }
    } else {
        console.log('no user');
    }
};

export default {};